import requests from "./httpService";

const orderServices = {
    createOrder (body) {
    return requests.post(`/orders/create`, body);
  },

  getOrderById(orderId) {
    return requests.get(`/orders/order-by-id/${orderId}`);
  },
  // Tranzila server-to-server webhook (MUST be POST)
  tranzilaNotify(body) {
    return requests.post(`/orders/tranzila-notify`, body);
  },
  // Frontend redirects here after iframe
  paymentStatus(body) {
    return requests.get(`/orders/payment-status`, body);
  },
};

export default orderServices;

